__turbopack_context__.v({
  "contentColumn": "Quy4JG_contentColumn",
  "description": "Quy4JG_description",
  "eyebrow": "Quy4JG_eyebrow",
  "glassBody": "Quy4JG_glassBody",
  "glassCard": "Quy4JG_glassCard",
  "glassEyebrow": "Quy4JG_glassEyebrow",
  "glassTitle": "Quy4JG_glassTitle",
  "header": "Quy4JG_header",
  "heading": "Quy4JG_heading",
  "inner": "Quy4JG_inner",
  "item": "Quy4JG_item",
  "itemButton": "Quy4JG_itemButton",
  "itemDescBloomIn": "Quy4JG_itemDescBloomIn",
  "itemDescription": "Quy4JG_itemDescription",
  "itemList": "Quy4JG_itemList",
  "itemSeparator": "Quy4JG_itemSeparator",
  "itemTitle": "Quy4JG_itemTitle",
  "mediaCard": "Quy4JG_mediaCard",
  "mediaColumn": "Quy4JG_mediaColumn",
  "mediaImage": "Quy4JG_mediaImage",
  "mobileMediaCard": "Quy4JG_mobileMediaCard",
  "mobileMediaImage": "Quy4JG_mobileMediaImage",
  "plusIcon": "Quy4JG_plusIcon",
  "section": "Quy4JG_section",
});
